import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('productOptionTypes', [
      'rawProductOptionTypes',
      'isLoadingProductOptionTypes',
      'productOptionsReviewsCountMap'
    ]),
    productOptionTypes() {
      return this.rawProductOptionTypes.filter(
        t => t.product_option_values.length > 1
      );
    },
    productOptionTypesWithCount() {
      return this.rawProductOptionTypes
        .filter(t => t.product_option_values.length > 1)
        .map(t => {
          return {
            ...t,
            product_option_values: t.product_option_values.map(v => {
              return {
                ...v,
                name_with_count: `${v.name} (${this.productOptionReviewCount(
                  t.id,
                  v.value
                )})`
              };
            })
          };
        });
    }
  },
  methods: {
    ...mapActions('productOptionTypes', ['fetchProductOptionTypes']),
    productOptionReviewCount(typeId, valueId) {
      return this.productOptionsReviewsCountMap?.[typeId]?.[valueId] || 0;
    }
  }
};
